import { spaceMixin } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledImageCarousel = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 438px;
    position: relative;

    .ImageCarousel-Viewport {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .ImageCarousel-ImageList-Container {
        display: flex;
        align-items: center;

        position: absolute;
        height: 100%;
        width: 100%;
    }

    /* mui - extend */
    .SpinnerContainer {
        margin: 0 auto;
    }

    .ImageCarousel-SwipeCarousel {
        width: 100%;
        height: 100%;

        > div {
            height: 100%;
        }
    }

    /* ImageContainer - extend */
    .ImageContainer {
        display: inline-block;
    }

    .ImageCarousel-actions-container {
        position: absolute;
        width: 100%;
        height: 50px;
    }

    .Action {
        display: flex;
        align-items: center;
        justify-content: center;

        position: absolute;
        width: 35px;
        height: 100%;
        border: 1px solid #fff;
        background-color: rgba(51, 51, 51, 0.75);
        cursor: pointer;

        /* mui - extend */
        &.disabled {
            opacity: .3;
            pointer-events: none;
        }
    }

    .Action-Prev {
        left: ${spaceMixin('xs')};
    }

    .Action-Next {
        right: ${spaceMixin('xs')};
    }
`;
